import React from 'react';
import { bookThemes, product } from '../../data/product';
export function BookSection() {
  return <section id="libro" aria-labelledby="libro-titulo" className="w-full bg-paper" data-id="element-60" data-mp="1l2set7nus8y1">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-36" data-id="element-61" data-mp="17bdsaquqlpm8">
        <div className="max-w-3xl" data-id="element-62" data-mp="179b7cl8fymod">
          <p className="text-sm text-stone" data-id="element-63" data-mp="1bc7m20uv1yn1">Un libro de {product.author}</p>
          <h2 id="libro-titulo" className="mt-4 font-serif text-[2.4rem] font-normal leading-[1.05] tracking-tight text-carbon sm:text-5xl lg:text-6xl" data-id="element-64" data-mp="xcy4oxux4yhh">
            {product.title} <em className="italic text-gold-ink" data-id="element-65" data-mp="ocjf3max8x86">— {product.titleTail}</em>
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-stone" data-id="element-66" data-mp="sdv881t080l4">
            Un libro sobre el valor de dejar de postergar y comenzar a vivir desde hoy.
          </p>
        </div>

        <div className="mt-16 grid gap-12 lg:mt-20 lg:grid-cols-12 lg:gap-12" data-id="element-67" data-mp="2iogbzus4uvam">
          <aside aria-label="Qué significa pobreza de espíritu" className="rounded-sm border border-sand bg-ivory p-8 lg:col-span-5 lg:p-10" data-id="element-68" data-mp="2mr36k3g6uubi">
            <div className="h-0.5 w-10 bg-gold" aria-hidden="true" data-id="element-69" data-mp="1amaqf90bw7zc" />
            <p className="mt-6 font-serif text-2xl text-carbon" data-id="element-70" data-mp="1pci0p1g6mkoy">
              Pobreza de Espíritu
            </p>
            <p className="mt-1 text-sm italic text-stone" data-id="element-71" data-mp="1kcly96n4v1bi">no es pobreza económica</p>
            <p className="mt-6 text-base leading-relaxed text-carbon" data-id="element-72" data-mp="wmrl0nywjaqq">
              No habla de dinero. Habla de renunciar a lo que deseas por miedo a la mirada ajena, y
              de la riqueza que aparece cuando te atreves a intentarlo.
            </p>
          </aside>

          <div className="lg:col-span-6 lg:col-start-7" data-id="element-73" data-mp="11mdwosz30ixf">
            <h3 className="text-sm font-medium text-stone" data-id="element-74" data-mp="11kt2x5kld40m">Lo que encontrarás en sus páginas</h3>
            <ul className="mt-6 divide-y divide-sand border-y border-sand" data-id="element-75" data-mp="2hz2qvykx8qqx">
              {bookThemes.map(theme => <li key={theme.title} className="py-6" data-id="element-76" data-mp="2d3ngjgm4hcz9">
                  <p className="font-serif text-xl text-carbon" data-id="element-77" data-mp="2k3pmkkpnxr5v">{theme.title}</p>
                  <p className="mt-1 text-base leading-relaxed text-stone" data-id="element-78" data-mp="2p3awtraa9lxw">{theme.body}</p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}